import React, { useState, useEffect } from "react";
import { modifySelectedCred } from "../../../redux/actions/credActions";
import { useSelector, useDispatch } from "react-redux";
import AtlassianFormBuilder from "../../../formBuilder/AtlassianFormBuilder";
import { clone } from "../../../common/utils/helper";

const BasicAuthPage = () => {
  const dispatch = useDispatch();
  const selectedCred = useSelector((state) => state.auth.selectedCred);
  const [values, setValues] = useState([]);

  const callback = (extConfigValues) => {
    let credentials = clone(selectedCred);
    credentials.name = extConfigValues.find((v) => v.id === "NAME").value;
    if (!credentials.data) {
      credentials.data = {
        password: "",
        username: "",
      };
    }
    credentials.data.username = extConfigValues.find((v) => v.id === "USERNAME").value;
    credentials.data.password = extConfigValues.find((v) => v.id === "PASSWORD").value;

    dispatch(modifySelectedCred(credentials));
  };

  useEffect(() => {
    setValues([
      {
        id: "NAME",
        value: selectedCred.name,
      },
      {
        id: "USERNAME",
        value: selectedCred.data ? selectedCred.data.username : "",
      },
      {
        id: "PASSWORD",
        value: selectedCred.data ? selectedCred.data.password : "",
      },
    ]);
  }, [selectedCred]);

  const fields = [
    {
      id: "NAME",
      title: "Credential name",
      type: "TEXT",
    },
    {
      id: "USERNAME",
      title: "Username",
      type: "TEXT",
    },
    {
      id: "PASSWORD",
      title: "Password",
      type: "TEXT",
      isPassword: true,
    },
  ];

  return (
    <>
      <AtlassianFormBuilder fields={fields} values={values} options={[]} update={callback} />
    </>
  );
};
export default BasicAuthPage;
